export default __webpack_public_path__ + "static/media/Medium Grenade.0382853c.PNG";